(ns app.front.view.group.admin.review-config
  (:require [app.domain.group.model :as group-model]
            [app.domain.review.model :as review-model]
            [app.domain.target-time.model :as target-time-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.components :as uic]
            [app.front.ui.config-pills :as config-pills]
            [app.front.ui.dnd :as dnd]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.radio :as ui-radio]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.ui.sortable-table :as sortable-table]
            [app.front.ui.table :as ui-table]
            [app.front.util :refer [for-frag] :as futil]
            [app.front.view.group.admin.feature-toggle :as feature-toggle]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.string :as str-util]
            [core.util.util :as util]
            [goog.functions]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(def integration-fields [:review.integration/code
                         :review.integration/ok-result-code
                         :review.integration/expected-status-code
                         :review.integration/changes-required-result-code])

(defn a-if-same [{id-a :db/id :as entity-a} {id-b :db/id :as entity-b}]
  (if (= id-a id-b)
    entity-a
    entity-b))


(defn replace-entity
  "Given entity `e`, replace that entity from a collection.

  If `e` is nil, does nothing. If `e` has no `:db/id`, appends."
  [{:db/keys [id] :as entity} all]
  (cond
    id (map (partial a-if-same entity) all)
    entity (conj all entity)
    :else all))


(rf/reg-event-fx ::fetch-review-assignees
  (fn [_ [_ group-entity-id]]
    {:dispatch [:comm/command-monitored {:command    :group/review-users
                                         :data       {:authority-group group-entity-id}
                                         :on-success [::entities/merge-entity-db]}]}))


(rf/reg-event-fx ::create-review.config.success
  (fn [{:keys [db]} [_ status changes]]
    {:db       (dissoc db ::current-review-config)
     :dispatch [::entities/apply-changes status changes]}))


(defn assignee->id [config-data]
  (-> config-data
      (p/update-if-contains :review.config/default-assignee :db/id)))

(defn- remove-default-dates-from-manual [config-data]
  (apply dissoc config-data (review-model/due-date-default-fields-to-clear config-data)))

(rf/reg-event-fx ::set-review-config.success
  (fn [{:keys [db]} [_ config-id automatic? status changes]]
    {:db (cond-> db
           (and (= config-id (get-in db [::current-review-config :db/id]))
                (not automatic?))
           (update ::current-review-config remove-default-dates-from-manual))
     :fx [[:dispatch [::entities/apply-changes status changes]]]}))

(rf/reg-event-fx ::set-review-config
  (fn [_ [_ group-id config-id data integration-included?]]
    {:comm/command {:command    :group/set-review-config
                    :data       {:group-id              group-id
                                 :review-config-id      config-id
                                 :data                  (-> data
                                                            (dissoc :db/id
                                                                    :ordered/order
                                                                    :review.config/key
                                                                    :review.config/group+key)
                                                            assignee->id
                                                            remove-default-dates-from-manual)
                                 :integration-included? integration-included?}
                    :notify     {:success :changes-saved}
                    :on-success [::set-review-config.success config-id (:review.config/due-date-auto? data)]}}))

(rf/reg-event-fx ::set-review-due-date-round-policy
  (fn [_ [_ group-id review-due-date-round-policy]]
    {:comm/command {:command    :group/set-review-due-date-round-policy
                    :data       {:group-id                           group-id
                                 :group/review-due-date-round-policy review-due-date-round-policy}
                    :notify     {:success :changes-saved}
                    :on-success [::entities/apply-changes]}}))


(rf/reg-event-fx ::create-review-config
  (fn [_ [_ group-id data]]
    {:comm/command {:command    :group/create-review-config
                    :data       {:group-id group-id
                                 :data     (-> data
                                               assignee->id
                                               remove-default-dates-from-manual)}
                    :notify     {:success :changes-saved}
                    :on-success [::create-review.config.success]}}))


(rf/reg-event-fx ::remove-review-config
  (fn [_ [_ group-id review-config-id]]
    {:comm/command {:command    :group/remove-review-config
                    :data       {:group-id         group-id
                                 :review-config-id review-config-id}
                    :notify     {:success :review.config/removed}
                    :on-success [::remove-review-config.success]}}))


(rf/reg-event-fx ::remove-review-config.success
  (fn [{:keys [db]} [_ status changes]]
    {:db       (dissoc db ::current-review-config)
     :dispatch [::entities/apply-changes status changes]}))


(defn get-form-fields [data]
  (let [form-data (-> data
                      (select-keys [:db/id
                                    :ordered/order
                                    :domain/state
                                    :review.config/key
                                    :review.config/name
                                    :review.config/user-addable?
                                    :review.integration/code
                                    :review.integration/ok-result-code
                                    :review.integration/expected-status-code
                                    :review.integration/changes-required-result-code
                                    :review.config/default-assignee
                                    :review.config/start-after-previous-finished?
                                    :review.config/create-task-after-previous-reviews-finished?
                                    :review.config/due-date-enabled?
                                    :review.config/due-date-auto?
                                    :review.config/due-date-default-value
                                    :review.config/due-date-default-unit
                                    :review.config/final-review?])
                      (update :review.config/name i18n-model/strings-map))]
    (cond-> form-data
      (:review.config/final-review? form-data)
      (assoc :review.config/start-after-previous-finished? false
             :review.config/create-task-after-previous-reviews-finished? false))))


(rf/reg-event-db ::clear-integration-fields
  (fn [db _]
    (update db ::current-review-config
            #(apply dissoc % integration-fields))))


(rf/reg-sub ::all-review-configs
  (fn [[_ group-id]]
    [(rf/subscribe [::entities/entities {:domain/authority-group group-id
                                         :entity/type            :entity.type/review-config}])
     (rf/subscribe [::current-review-config])])
  (fn [[configs current] _]
    (->> configs
         (replace-entity current)
         (remove (du/in-state-fn :review.config.state/removed))
         (sort-by :ordered/order du/compare-nil-last))))


(rf/reg-sub ::available-review-configs
  (fn [[_ group-id]]
    (rf/subscribe [::all-review-configs group-id]))
  (fn [all _]
    (->> all
         (filter (du/in-state-fn :review.config.state/active)))))

(rf/reg-sub ::available-final-review-config-ids
  (fn [[_ group-id]]
    (rf/subscribe [::available-review-configs group-id]))
  (fn [available-review-configs]
    (->> available-review-configs
         (filter :review.config/final-review?)
         (map :db/id)
         set)))

(defn- get-name-str [language review-config]
  (review-model/review-config-name review-config language))


(rf/reg-sub ::has-name?
  :<- [::ui-i18n/editor-language ::gas/allowed-locales]
  :<- [::current-review-config]
  (fn [[language form-data] _]
    (->> form-data (get-name-str language) str/blank?)))

(rf/reg-event-db ::select-review-config-for-edit
  (fn [db [_ item]]
    (if item
      (assoc db ::current-review-config (get-form-fields item))
      (dissoc db ::current-review-config))))


(rf/reg-sub ::current-review-config
  :-> ::current-review-config)


(rf/reg-event-db ::clear-current-review-config
  #(dissoc % ::current-review-config))


(rf/reg-sub ::id-of-current-review-config
  :<- [::current-review-config]
  :-> :db/id)


(rf/reg-sub ::adding-new?
  :<- [::current-review-config]
  (fn [current _]
    (and
      current
      (-> current :db/id nil?))))


(rf/reg-sub ::assignees
  :<- [:session/user]
  :<- [::entities/entities {:entity/type :entity.type/user}]
  :<- [::gas/group]
  (fn [[user users auth-group] _]
    (->> users
         (filter (partial review-model/is-reviewer? auth-group))
         (sort (partial user-model/user-sort (:db/id user))))))


(rf/reg-sub ::default-assignee-groups
  :<- [::gas/group]
  (fn [auth-group _]
    (sort-by :group/name (group-model/review-assignment-groups auth-group))))


(rf/reg-event-fx ::reorder
  (fn [_ [_ group-id new-order]]
    {:comm/command {:command    :group/reorder-review-configs
                    :data       {:reorder-configs    new-order
                                 :authority-group-id group-id}
                    :on-success [::entities/apply-changes]}}))


(rf/reg-event-db ::add-new-review-config
  (fn [db _]
    (-> db
        (assoc ::current-review-config {:domain/state                :review.config.state/active
                                        :review.config/user-addable? false}))))


(rf/reg-event-db ::set-review-config-value
  (fn [db [_ key value]]
    (if (and (= key :review.config/default-assignee)
             (nil? value))
      (p/dissoc-in db [::current-review-config key])
      (cond-> (assoc-in db [::current-review-config key] value)
        (and (= key :review.config/final-review?) value)
        (-> (assoc-in [::current-review-config :review.config/start-after-previous-finished?] false)
            (assoc-in [::current-review-config :review.config/create-task-after-previous-reviews-finished?] false))))))


(defn review-config-title [tr review-config]
  (let [language (<sub [::ui-i18n/editor-language ::gas/allowed-locales])]
    [:span
     (when (:review.config/start-after-previous-finished? review-config)
       (cc/icon {:icon        i/dependency
                 :class-name  "mr-1"
                 :description (tr [:review.config/start-after-previous-finished])}))
     [:span
      (get-name-str language review-config)]
     [:span (when-some [integration-code (:review.integration/code review-config)]
              (str " ❘ " integration-code))]]))


(defn assignee-dropdown [{:keys [id tr default-assignee]}]
  (let [assignees (<sub [::assignees])
        groups    (when (ff/enabled? :feature-flag.id/review-assignment-groups)
                    (<sub [::default-assignee-groups]))]
    (cond
      (<sub [:comm/command-processing? :group/review-users])
      [:div.w-48 (cc/select-skeleton)]

      (or (seq assignees) (seq groups))
      [ui-select/select
       {:id         (str "default-assignee-" id)
        :data-cy    "select-default-reviewer"
        :label-text (tr [:review.config/default-assignee])
        :tr         tr
        :value      default-assignee
        :values     (concat assignees groups)
        :val->str   (fn [entity]
                      (if (group-model/review-assignment-group? entity)
                        (:group/name entity)
                        (user-model/full-name entity)))
        :grouper    (when (seq groups)
                      (fn [entity]
                        (if (group-model/review-assignment-group? entity)
                          (tr [:review/assignment-group])
                          (tr [:review/reviewer]))))
        :empty-text (tr [:review/unassigned])
        :on-change  #(>evt [::set-review-config-value :review.config/default-assignee %])}]

      :else
      [:<>
       [:label.bx--label (tr [:review.config/default-assignee])]
       [:div.bold {:data-cy "no-reviewers"} (tr [:review/no-reviewers])]])))


(defn config-editor [{:keys [tr group-id]}
                     {:db/keys            [id]
                      :review.config/keys [name user-addable? default-assignee
                                           start-after-previous-finished?
                                           create-task-after-previous-reviews-finished?
                                           due-date-enabled? due-date-default-value due-date-default-unit
                                           final-review?]
                      :as                 data}
                     index]
  (r/with-let [*integration-included? (r/atom (-> data :review.integration/code some?))]
    (let [original-config                        (<sub [::entities/entity id])
          changed?                               (not= (-> original-config
                                                           get-form-fields
                                                           assignee->id
                                                           remove-default-dates-from-manual)
                                                       (-> data
                                                           assignee->id
                                                           remove-default-dates-from-manual))
          has-name?                              (<sub [::has-name?])
          first?                                 (= index 0)
          due-date-calc-required-and-configured? (review-model/due-date-calc-required-and-configured? data)
          due-date-auto?                         (boolean (:review.config/due-date-auto? data))]
      [:<>
       [ui-i18n/edit-language-selector {:allowed-locales-sub ::gas/allowed-locales}]
       [uic/form-field-wide
        [ui-i18n/localized-string-edit
         {:id                  (str "review-config:" id ":name")
          :allowed-locales-sub ::gas/allowed-locales
          :label-text          (tr [:review.config/review-name])
          :strings             name
          :required            true
          :on-change           #(rf/dispatch-sync [::set-review-config-value :review.config/name %])}]]
       [uic/form-field-wide
        [:div.flex.flex-row.justify-between.bx--form-item
         [:div.flex.flex-row
          [:label.bx--label.mr-2 (tr [:review.config/review-enabled])]
          (cc/toggle {:toggled    (du/in-state? :review.config.state/active data)
                      :id         (str "review-config:" id ":state")
                      :labelA     (tr [:no])
                      :labelB     (tr [:yes])
                      :class-name "unlabeled-toggle"
                      :on-toggle  #(>evt [::set-review-config-value :domain/state
                                          (if %
                                            :review.config.state/active
                                            :review.config.state/disabled)])})]
         [:div.flex.flex-row
          [:div
           (when (ff/enabled? :feature-flag.id/final-review)
             [:div
              (cc/checkbox {:id         (str "review-config:" id ":final-review")
                            :class-name "mr-2"
                            :label-text (tr [:review.config/final-review])
                            :checked    (boolean final-review?)
                            :on-change  (fn [value]
                                          (>evt [::set-review-config-value :review.config/final-review? value])
                                          (when value
                                            (>evt [::set-review-config-value :review.config/start-after-previous-finished? false])))})])
           (when final-review?
             [:div.mt-1.text-xs.text-gray-600
              (tr [:review.config/final-review-requires-default-assignee])])
           (cc/checkbox {:id         (str "review-config:" id ":task-precedence")
                         :label-text (tr [:review.config/create-task-after-previous-reviews-finished])
                         :checked    (boolean create-task-after-previous-reviews-finished?)
                         :disabled   (or final-review?
                                         (and (not create-task-after-previous-reviews-finished?) ;; Allow unchecking but not checking for 1st
                                              first?))
                         :on-change  (fn [value]
                                       (>evt [::set-review-config-value :review.config/create-task-after-previous-reviews-finished? value])
                                       (when (not value)
                                         (>evt [::set-review-config-value :review.config/start-after-previous-finished? false])))})
           (cc/checkbox {:id         (str "review-config:" id ":precedence")
                         :class-name "mr-2"
                         :label-text (tr [:review.config/start-after-previous-finished])
                         :checked    (boolean start-after-previous-finished?)
                         :disabled   (or (and (not start-after-previous-finished?) ;; Allow unchecking but not checking for 1st
                                              first?)
                                         (not create-task-after-previous-reviews-finished?)
                                         (boolean final-review?))     ;; Final reviews cannot wait for previous
                         :on-change  #(>evt [::set-review-config-value :review.config/start-after-previous-finished? %])})]]
         [:div.flex.flex-row
          [:div
           (cc/checkbox {:id         (str "review-config:" id ":user-addable")
                         :class-name "mr-2"
                         :label-text (tr [:review.config/user-addable])
                         :checked    user-addable?
                         :on-change  #(>evt [::set-review-config-value :review.config/user-addable? %])})]
          (when (or (<sub [::gas/has-feature? :group.feature/backend-system-integration])
                    @*integration-included?)
            [:div
             (cc/checkbox {:id         (str "review-config:" id "integration-included")
                           :label-text (tr [:review.config/integration-included])
                           :checked    @*integration-included?
                           :on-change  (fn [checked?]
                                         (reset! *integration-included? checked?)
                                         (when-not checked? (>evt [::clear-integration-fields])))})])]]]
       [uic/form-field
        [assignee-dropdown (util/mmap id tr default-assignee)]]
       (when (and
               (ff/enabled? :feature-flag.id/review-due-date)
               (<sub [::gas/has-feature? :group.feature/review-due-date]))
         [:div.mt-4
          [:h5.mb-2 (tr [:review.config/due-date-enabled])]
          [ui/help (tr [:review.config/due-date-help])]
          [:div
           (cc/checkbox {:id         (str "review-config:" id ":due-date-enabled")
                         :label-text (tr [:review.config/due-date-enabled])
                         :checked    (boolean due-date-enabled?)
                         :on-change  (fn [value]
                                       (>evt [::set-review-config-value :review.config/due-date-enabled? value]))})]
          (when due-date-enabled?
            [:<>
             [:div.mt-2
              [ui-radio/radio {:name       (str "review-config:" id ":due-date-mode")
                               :values     [false true]
                               :value      due-date-auto?
                               :label-text (tr [:review.config/due-date-mode])
                               :val->str   #(tr [(if %
                                                   :review.config/due-date-mode-auto
                                                   :review.config/due-date-mode-manual)])
                               :on-change  #(>evt [::set-review-config-value
                                                   :review.config/due-date-auto?
                                                   %])}]]
             (when due-date-auto?
               [:<>
                [:div.flex.gap-x-4.mt-2
                 [:div
                  [ui/number-input {:id            (str "review-config:" id ":due-date-default-value")
                                    :label-text    (tr [:review.config/due-date-default-value])
                                    :default-value due-date-default-value
                                    :min           1
                                    :required      true
                                    :on-change     #(>evt [::set-review-config-value
                                                           :review.config/due-date-default-value
                                                           (some-> % futil/tval str-util/blank->nil js/parseInt)])}]]
                 [ui-select/select
                  {:id           (str "review-due-date-unit-" id)
                   :label-text   (tr [:review.config/due-date-default-unit])
                   :val->str     #(tr [%])
                   :value        due-date-default-unit
                   :required     true
                   :allow-empty? false
                   :values       target-time-model/target-time-unit-choice-days
                   :on-change    #(>evt [::set-review-config-value :review.config/due-date-default-unit %])}]]
                (when-not due-date-calc-required-and-configured?
                  [:div.mt-1.text-xs.text-gray-600 (tr [:review.config/due-date-mode-requires-calc])])])])])
       (when @*integration-included?
         [:div
          [:div.bx--row.mt-4
           [:div.bx--col
            [:h5 (tr [:review.config/integration-configuration])]]]
          [:div.bx--row.mt-4
           (for-frag [attribute integration-fields]
             [:div.bx--col-xs-12.bx--col-md-6.bx--col-xl-3
              [ui/number-input {:id         (str "review-config:" id ":" (name attribute))
                                :label-text (tr [attribute])
                                :value      (or (-> data attribute) "")
                                :required   (= attribute :review.integration/code)
                                :on-change  #(rf/dispatch-sync
                                               [::set-review-config-value
                                                attribute
                                                (futil/tval %)])}]])]])
       [:div.flex.mt-4
        [:div.ml-auto
         (cc/button
           {:on-click   (fn [_]
                          (>evt [::clear-current-review-config]))
            :kind       :tertiary
            :disabled   (not changed?)
            :class-name "mr-2"}
           (tr [:cancel-changes]))
         (cc/button
           {:on-click (fn []
                        (if id
                          (>evt [::set-review-config
                                 group-id
                                 id
                                 data
                                 @*integration-included?])
                          (>evt [::create-review-config
                                 group-id
                                 data])))
            :disabled (boolean (or (not changed?)
                                   has-name?
                                   (and due-date-enabled? (not due-date-calc-required-and-configured?) due-date-auto?)
                                   (and @*integration-included? (-> data :review.integration/code str/blank?))
                                   (and final-review? (nil? default-assignee))))}
           (tr [(if (nil? data) :save :save-changes)]))
         (when (and id
                    (du/in-state? :review.config.state/disabled original-config)
                    (ff/enabled? :feature-flag.id/review-config-removal))
           [ui/modal-confirmation-button
            {:tr                  tr
             :id                  (str "remove-review-config-" id)
             :trigger-button-opts {:kind       :danger
                                   :class-name "ml-2"}
             :trigger-button-text (tr [:remove])
             :on-yes-click        #(>evt [::remove-review-config group-id id])}
            [:p (tr [:review.config/remove-confirmation])]])]]])))


(defn review-config-table [{:keys [tr group-id wrapped-editor]}]
  #_{:clj-kondo/ignore [:deprecated-var]}
  [ui-table/table-2
   {:id                (str "review-config-table-" group-id)
    :items             (<sub [::all-review-configs group-id])
    :header+extractors (concat [[:review.config/review-name
                                 (partial review-config-title tr)]
                                [:review.config/default-assignee
                                 (fn [review-config]
                                   (let [default-assignee (:review.config/default-assignee review-config)]
                                     (if (and
                                           (ff/enabled? :feature-flag.id/review-assignment-groups)
                                           (group-model/review-assignment-group? default-assignee))
                                       (:group/name default-assignee)
                                       (user-model/full-name default-assignee))))]
                                [:review.config/status
                                 (fn [review-config]
                                   (if (du/in-state? :review.config.state/active review-config)
                                     (tr [:review.config/enabled])
                                     (tr [:review.config/disabled])))]
                                [""
                                 (fn [review-config] (when (some? (:review.integration/code review-config))
                                                       (cc/icon {:icon        i/link
                                                                 :description (tr [:review.config/has-integration])
                                                                 :class-name  "inline-block align-middle"})))]])
    :expand-component  wrapped-editor
    :on-expand         #(>evt [::select-review-config-for-edit %])
    :expanded?         (comp (partial = (<sub [::id-of-current-review-config])) :db/id)
    :tr                (<sub [:tr])
    :on-reorder        (when (not (<sub [::adding-new?]))
                         (fn [from to]
                           (>evt [::reorder
                                  group-id
                                  (dnd/ordering-tx-for-entity from to)])))}])


;; --- Review assignment groups -----------------------------------------------------

(rf/reg-event-fx ::fetch-assignment-groups
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/review-assignment-groups
                    :method     :get
                    :data       {:authority-group-id group-id}
                    :on-success [::fetch-assignment-groups.success]}}))


(rf/reg-event-fx ::fetch-assignment-groups.success
  (fn [{:keys [db]} [_ status {:keys [entities review-counts]}]]
    (cond-> {:db (assoc db ::assignment-group-review-counts review-counts)}
      (some? entities)
      (assoc :fx [[:dispatch [::entities/merge-entity-db status entities]]]))))


(rf/reg-sub ::assignment-group-review-counts
  :-> ::assignment-group-review-counts)


(rf/reg-sub ::assignment-groups
  :<- [::assignment-group-review-counts]
  :<- [::entities/entities {:entity/type :entity.type/group}]
  (fn [[review-counts groups] _]
    (->> groups
         (filter group-model/review-assignment-group?)
         (filter #(contains? review-counts (:db/id %)))
         (sort-by :group/name))))


(rf/reg-sub ::edited-assignment-group
  :-> ::edited-assignment-group)


(rf/reg-event-db ::assignment-group-open
  (fn [db [_ group]]
    (assoc db ::edited-assignment-group
           (if group
             {:db/id      (:db/id group)
              :group/name (:group/name group)
              :member-ids (->> group group-model/get-users-in-group (map :db/id) set)}
             {:group/name ""
              :member-ids #{}}))))


(rf/reg-event-db ::assignment-group-close
  (fn [db _]
    (dissoc db ::edited-assignment-group)))


(rf/reg-event-db ::set-assignment-group-name
  (fn [db [_ name]]
    (assoc-in db [::edited-assignment-group :group/name] name)))


(rf/reg-event-db ::add-assignment-group-member
  (fn [db [_ id]]
    (update-in db [::edited-assignment-group :member-ids] (fnil conj #{}) id)))


(rf/reg-event-db ::remove-assignment-group-member
  (fn [db [_ id]]
    (update-in db [::edited-assignment-group :member-ids] (fnil disj #{}) id)))


(rf/reg-sub ::assignment-group-name-taken?
  :<- [::assignment-groups]
  :<- [::edited-assignment-group]
  (fn [[groups edited] _]
    (when edited
      (-> (remove #(= (:db/id %) (:db/id edited)) groups)
          (p/find-first #(str-util/normalized-equals? (:group/name %)
                                                      (:group/name edited)))
          some?))))


(rf/reg-sub ::assignment-group-save-disabled?
  :<- [::edited-assignment-group]
  :<- [::assignment-group-name-taken?]
  (fn [[edited name-taken?] _]
    (or (str/blank? (:group/name edited))
        name-taken?
        (empty? (:member-ids edited)))))


(rf/reg-event-fx ::assignment-group-saved
  (fn [_ [_ group-id]]
    {:fx [[:dispatch [::assignment-group-close]]
          [:dispatch [::fetch-assignment-groups group-id]]]}))


(rf/reg-event-fx ::save-assignment-group
  (fn [{:keys [db]} [_ group-id]]
    (let [{:group/keys [name] :db/keys [id] :keys [member-ids]} (::edited-assignment-group db)
          member-ids                                            (vec member-ids)]
      {:comm/command (if id
                       {:command          :group/edit-review-assignment-group
                        :data             {:authority-group-id group-id
                                           :group-id           id
                                           :group-name         name
                                           :member-ids         member-ids}
                        :on-success       [::entities/apply-changes]
                        :notify           {:success :changes-saved}
                        :finally-dispatch [::assignment-group-saved group-id]}
                       {:command          :group/create-review-assignment-group
                        :data             {:authority-group-id group-id
                                           :group-name         name
                                           :member-ids         member-ids}
                        :on-success       [::entities/apply-changes]
                        :notify           {:success :changes-saved}
                        :finally-dispatch [::assignment-group-saved group-id]})})))


(rf/reg-sub ::deleting-assignment-group
  :-> ::deleting-assignment-group)


(rf/reg-sub ::deleting-assignment-group-review-count
  :<- [::deleting-assignment-group]
  :<- [::assignment-group-review-counts]
  (fn [[group review-counts] _]
    (when group
      (get review-counts (:db/id group) 0))))


(rf/reg-event-fx ::delete-assignment-group-open
  (fn [{:keys [db]} [_ group-id assignment-group]]
    {:db       (assoc db ::deleting-assignment-group (select-keys assignment-group [:db/id :group/name]))
     :dispatch [::fetch-assignment-groups group-id]}))


(rf/reg-event-db ::delete-assignment-group-close
  (fn [db _]
    (dissoc db ::deleting-assignment-group)))


(rf/reg-event-fx ::assignment-group-deleted
  (fn [_ [_ group-id]]
    {:fx [[:dispatch [::delete-assignment-group-close]]
          [:dispatch [::fetch-assignment-groups group-id]]]}))


(rf/reg-event-fx ::remove-assignment-group
  (fn [_ [_ group-id group-eid]]
    {:comm/command {:command          :group/remove-review-assignment-group
                    :data             {:group-id group-eid}
                    :on-success       [::entities/apply-changes]
                    :notify           {:success :changes-saved}
                    :finally-dispatch [::assignment-group-deleted group-id]}}))


(defn- assignee-label [user]
  (let [full-name (user-model/full-name user)
        email     (:user/email user)]
    (if (str/blank? email)
      full-name
      (str full-name " (" email ")"))))


(defn assignment-group-modal [tr]
  (let [edited      (<sub [::edited-assignment-group])
        new?        (-> edited :db/id nil?)
        name-taken? (<sub [::assignment-group-name-taken?])
        disabled?   (<sub [::assignment-group-save-disabled?])
        assignees   (<sub [::assignees])
        group-id    (<sub [::gas/group-id])
        close-fn    #(>evt [::assignment-group-close])]
    [ui-modal/composed-input-modal
     {:open                   (some? edited)
      :selector-primary-focus "#review-assignment-group-name"
      :on-close               close-fn}
     (cc/modal-header {:close-modal close-fn
                       :title       (tr [(if new? :review-assignment-group/add :review-assignment-group/edit)])})
     (when edited
       (cc/modal-body
         {}
         [:div.my-4.flex.flex-col.gap-4
          [ui/text-input {:id           "review-assignment-group-name"
                          :label-text   (tr [:admin/group-name])
                          :value        (:group/name edited)
                          :invalid      name-taken?
                          :invalid-text (when name-taken? (tr [:admin/group-name-taken]))
                          :on-change    #(>evt [::set-assignment-group-name (futil/tval %)])}]
          [config-pills/config-pills
           {:id          "review-assignment-group-members"
            :legend-text (tr [:review-assignment-group/members])
            :required?   true
            :values      assignees
            :selected    (filter #(contains? (:member-ids edited) (:db/id %)) assignees)
            :val->str    assignee-label
            :val->id     :db/id
            :add-item    #(>evt [::add-assignment-group-member (:db/id %)])
            :remove-item #(>evt [::remove-assignment-group-member (:db/id %)])
            :tr          tr}]]))
     (cc/modal-footer
       {:primary-button-text     (tr [(if new? :create :save)])
        :primary-button-disabled disabled?
        :secondary-button-text   (tr [:cancel])
        :on-request-submit       #(>evt [::save-assignment-group group-id])
        :on-request-close        close-fn})]))


(defn delete-assignment-group-modal [tr group-id]
  (let [group        (<sub [::deleting-assignment-group])
        checking?    (<sub [:comm/command-processing? :group/review-assignment-groups])
        review-count (<sub [::deleting-assignment-group-review-count])]
    [ui/confirm-modal
     {:id              "delete-review-assignment-group"
      :tr              tr
      :open?           (some? group)
      :dangerous?      true
      :yes-disabled?   (boolean checking?)
      :modal-title     (tr [:review-assignment-group/delete-title])
      :yes-button-text (tr [:review-assignment-group/delete-confirm])
      :no-button-text  (tr [:cancel])
      :on-close        #(>evt [::delete-assignment-group-close])
      :on-yes-click    #(>evt [::remove-assignment-group group-id (:db/id group)])}
     (if checking?
       [:div.flex.items-center.gap-2
        (cc/loading-spinner {:small true :with-overlay false})
        [:span (tr [:review-assignment-group/delete-checking])]]
       [:p (tr [:review-assignment-group/delete-subtitle] [(str review-count)])])]))


(defn review-assignment-groups-section [tr group-id]
  (let [groups        (<sub [::assignment-groups])
        review-counts (<sub [::assignment-group-review-counts])]
    [:<>
     [assignment-group-modal tr]
     [delete-assignment-group-modal tr group-id]
     [section/section
      "review-assignment-groups"
      (util/mmap {:heading-button   [ui/button {:id       "add-review-assignment-group-button"
                                                :icon     i/plus
                                                :on-click #(>evt [::assignment-group-open])}
                                     (tr [:review-assignment-group/add])]
                  :always-expanded? true}
                 tr)
      (tr [:review-assignment-group/section-title])
      [:div.mb-4 (tr [:review-assignment-group/section-subtitle])]
      (if (empty? groups)
        [:div (tr [:review-assignment-group/no-groups])]
        [sortable-table/table
         {:cols            [[:admin/group-name :group/name {:sorting true}]
                            [:review-assignment-group/members
                             (fn [group]
                               (->> group
                                    group-model/get-users-in-group
                                    (map user-model/full-name)
                                    sort
                                    (str/join ", ")))]
                            [:review-assignment-group/assigned-reviews
                             (fn [group] (str (get review-counts (:db/id group) 0)))]]
          :items           groups
          :initial-sorting [:group/name :asc]
          :make-actions    (fn [group]
                             [{:title    (tr [:delete])
                               :icon     i/trash
                               :on-click #(>evt [::delete-assignment-group-open group-id group])}
                              {:title    (tr [:edit])
                               :icon     i/pen
                               :on-click #(>evt [::assignment-group-open group])}])
          :tr              tr}])]]))

(defn review-due-date-round-policy-select [tr group-id review-due-date-round-policy]
  (let [policy        (or review-due-date-round-policy review-model/default-due-date-round-policy)
        policy->label {:review.due-date-round-policy/continue         :review.config/due-date-round-policy-continue
                       :review.due-date-round-policy/pause-and-resume :review.config/due-date-round-policy-pause-and-resume
                       :review.due-date-round-policy/recalculate      :review.config/due-date-round-policy-recalculate}
        policy->help  {:review.due-date-round-policy/continue         :review.config/due-date-round-policy-continue-help
                       :review.due-date-round-policy/pause-and-resume :review.config/due-date-round-policy-pause-and-resume-help
                       :review.due-date-round-policy/recalculate      :review.config/due-date-round-policy-recalculate-help}]
    [:div.mb-4
     [ui-select/select
      {:id           "review-due-date-round-policy"
       :label-text   (tr [:review.config/due-date-round-policy])
       :value        policy
       :values       (sort review-model/review-due-date-round-policies)
       :class-name   "w-full lg:w-1-3"
       :allow-empty? false
       :val->str     (comp tr vector policy->label)
       :on-change    #(>evt [::set-review-due-date-round-policy group-id %])}]
     [ui/help (tr [(policy->help policy)])]]))


(defn actual-view [match tr group-id group]
  (r/with-let [wrapped-editor-fn (futil/make-callback-fn config-editor)]
    (let [group-name     (get group :group/name)
          wrapped-editor (wrapped-editor-fn (util/mmap tr group-id))]
      [:div.cloudpermit-page.flex.flex-1.flex-col
       [ui/page-header (util/mmap match)
        [:div.px-8.flex.justify-between
         [:h1 (str (tr [:review.config/manage-available-review-configs-title]) ": " group-name)]]]
       [:section>fieldset
        (when (<sub [::ff/enabled? :feature-flag.id/applicant-review-history])
          [:div
           {:data-guide-id    "detailed-applicant-review-history"
            :data-guide-label (tr [(feature-toggle/title-kw :group.feature/detailed-applicant-review-history)])}
           [feature-toggle/toggle-group-feature
            {:tr           tr
             :feature-name :group.feature/detailed-applicant-review-history}]])
        [feature-toggle/toggle-group-feature {:tr           tr
                                              :feature-name :group.feature/review-time-tracking}]
        [feature-toggle/toggle-group-feature {:tr           tr
                                              :feature-name :group.feature/reviews-in-submitted
                                              :feature-flag :feature-flag.id/reviews-in-submitted}]
        [feature-toggle/toggle-group-feature {:tr           tr
                                              :feature-name :group.feature/review-due-date
                                              :feature-flag :feature-flag.id/review-due-date}]
        (when (and (ff/enabled? :feature-flag.id/review-due-date)
                   (<sub [::gas/has-feature? :group.feature/review-due-date]))
          [review-due-date-round-policy-select tr group-id (:group/review-due-date-round-policy group)])
        [:<>
         [:h3.w-full.mb-2 (tr [:review.config/available-reviews])]
         [:div.mb-4 (tr [:review.config/manage-available-review-configs-subtitle])]
         [review-config-table (util/mmap tr group-id wrapped-editor)]
         (when (not (<sub [::adding-new?]))
           [ui-table/add-new-button
            {:tr         tr
             :class-name "mt-3"
             :on-click   #(>evt [::add-new-review-config])}
            (tr [:review.config/add-new-review])])]
        (when (ff/enabled? :feature-flag.id/review-assignment-groups)
          [review-assignment-groups-section tr group-id])]])))


(defn view [match]
  (let [tr           (<sub [:tr])
        group-id     (-> match :parameters :path :group-id)
        group        (<sub [::entities/entity group-id])
        group-config (<sub [::entities/entity {:group.config/group group-id
                                               :entity/type        :entity.type/group-config
                                               :entity/parent      nil}])]
    (if (nil? group-config)
      (cc/loading-spinner {:with-overlay true :small false})
      ^{:key (-> group-config :db/id)}
      [actual-view match tr group-id group])))


(def route
  {:name        :view/group.admin.review-config
   :view        view
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [params]
                                (let [group-id (-> params :path :group-id)]
                                  (>evt [::fetch-review-assignees group-id])
                                  ;; Always fetch; frontend feature flags load asynchronously via whoami, so gating
                                  ;; on ff/enabled? here can silently skip the fetch on a hard load/reload. The section
                                  ;; render is still flag-gated and re-renders reactively once flags arrive.
                                  (>evt [::fetch-assignment-groups group-id])))}]})
